import { useEffect, useState } from 'react';
import { format } from 'date-fns';
import { MaNtData, NgoaiTe, TyGiaQuyDoiNgoaiTe, TyGiaQuyDoiNgoaiTeInput } from '@/types/schemas';
import { AritoFormV2, AritoIcon, BottomActionBarV2, DialogV2 } from '@/components/custom/erp';
import { FormSchema, FormValues, initialFormValues } from '../../schemas';
import { BasicInfoTab } from './BasicInfoTab';
import { FormMode } from '@/types/form';

interface FormDialogProps {
  formMode: FormMode;
  open: boolean;
  initialData?: TyGiaQuyDoiNgoaiTe;
  onSubmit?: (data: TyGiaQuyDoiNgoaiTeInput) => void;
  onClose: () => void;
  onAdd?: () => void;
  onEdit?: () => void;
  onDelete?: () => void;
  onCopy?: () => void;
}

const FormDialog = ({
  open,
  onClose,
  onSubmit,
  formMode,
  initialData,
  onAdd,
  onEdit,
  onDelete,
  onCopy
}: FormDialogProps) => {
  const [isFormDirty, setIsFormDirty] = useState<boolean>(false);
  const [ngoaiTe, setNgoaiTe] = useState<NgoaiTe | MaNtData | null>(initialData?.ma_nt_data ?? null);

  useEffect(() => {
    if (!open) {
      setIsFormDirty(false);
    }
  }, [open]);

  const handleSubmit = (data: FormValues) => {
    onSubmit?.({ ...data, ma_nt: ngoaiTe?.uuid as string, ngay_hl: format(data.ngay_hl, 'yyyy-MM-dd') });
    setIsFormDirty(false);
    onClose();
  };

  return (
    <>
      <DialogV2
        open={open}
        onClose={onClose}
        title={formMode === 'add' ? 'Mới' : formMode === 'edit' ? 'Sửa' : 'Tỷ giá quy đổi ngoại tệ'}
        maxWidth='xl'
        disableBackdropClose={false}
        disableEscapeKeyDown={true}
        titleIcon={<AritoIcon icon={281} />}
      >
        <AritoFormV2
          mode={formMode}
          hasAritoActionBar={false}
          schema={FormSchema}
          onSubmit={handleSubmit}
          onClose={onClose}
          initialData={(initialData || initialFormValues) as FormValues}
          className='w-[800px] overflow-y-auto'
          headerFields={
            <div onChange={() => setIsFormDirty(true)}>
              <BasicInfoTab formMode={formMode} ngoaiTe={ngoaiTe} setNgoaiTe={setNgoaiTe} />
            </div>
          }
          bottomBar={
            <>
              <div className='ml-2 mt-2 w-full'></div>
              <BottomActionBarV2
                mode={formMode}
                onClose={onClose}
                onAdd={onAdd}
                onEdit={onEdit}
                onDelete={onDelete}
                onCopy={onCopy}
              />
            </>
          }
        />
      </DialogV2>
    </>
  );
};

export default FormDialog;
